import { 
    LOAD_LIST_PATIENT, LOAD_A_PATIENT, ADD_NEW_PATIENT, UPDATE_A_PATIENT, 
    DELETE_A_PATIENT, CLEAR_LIST_PATIENT, CLEAR_A_PATIENT_DETAIL, CLEAR_PATIENT_ACTION_STATUS, 
    DOC_EXPORT_PATIENT_LIST_TO_CSV, DOC_EXPORT_PATIENT_LIST_TO_EXCEL, 
    CLEAR_PATIENT_LIST_REMOTE_CSV, CLEAR_PATIENT_LIST_REMOTE_EXCEL
} from '../actionTypes';
import { SUCCESS_STATUS, FAILED_STATUS } from '../../constants';

const initialState = {
    patientList: [],
    patientDetail: null,
    totalCount: 0,
    limit: 10,
    offset: 0,
    loading: false,
    error: '',
    actionStatus: undefined,
    actionMsg: "",
    remoteCSV: null,
    remoteEXCEL: null,
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_LIST_PATIENT: {
            const { result, totalCount, limit, offset } = action.payload;
            return {
                ...state,
                patientList: result,
                totalCount,
                limit, 
                offset
            }
        }

        case LOAD_A_PATIENT: {
            return {
                ...state,
                patientDetail: action.payload
            }
        }

        case ADD_NEW_PATIENT: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                patientList: [
                    action.payload.data,
                    ...state.patientList
                ],
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case UPDATE_A_PATIENT: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                patientList: state.patientList.map(item => item.id !== action.payload.data.id ? item : action.payload.data),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case DELETE_A_PATIENT: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }
            
            return {
                ...state,
                loading: false,
                patientList: state.patientList.filter(item => item.id !== parseFloat(action.payload.data)),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case CLEAR_LIST_PATIENT: {
            return {
                ...state,
                patientList: [],
            }
        }

        case CLEAR_A_PATIENT_DETAIL: {
            return {
                ...state,
                patientDetail: null,
            }
        }

        case CLEAR_PATIENT_ACTION_STATUS: {
            return {
                ...state,
                actionStatus: undefined,
                actionMsg: ""
            }
        }

        case DOC_EXPORT_PATIENT_LIST_TO_CSV.SUCCESS:
            return {
                ...state,
                remoteCSV: action.payload,
            };

        case CLEAR_PATIENT_LIST_REMOTE_CSV: {
            return {
                ...state,
                remoteCSV: null,
            };
        }

        case DOC_EXPORT_PATIENT_LIST_TO_EXCEL.SUCCESS:
            console.log('')
            return {
                ...state,
                remoteEXCEL: action.payload,
            };

        case CLEAR_PATIENT_LIST_REMOTE_EXCEL: {
            return {
                ...state,
                remoteEXCEL: null,
            };
        }

        default:
            return state
    }
}